import React, { useState } from 'react'
import { IMAGE } from '../saas/Config/Color'

function AssetsPreview({open ,handleClose ,selectedImage ,title}) {
    const [count ,setCount] = useState(0)
    return (
        <div
            style={open ? { display: "block" } : {}}
            className={`modal fade ${open ? "show" : ""} `}
            id="edit_company" >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">{title || "Assets Image Preview"} </h4>
                        <button type="button"
                            className="btn-close custom-btn-close"
                            onClick={() => {
                                handleClose()
                            }}>
                            <i className="ti ti-x"></i>
                        </button>
                    </div>
                    <div className="image-preview-assets" >
                        <div style={{ justifyContent: "center", display: "flex" }}>
                            <span className="assets-p"
                                onClick={() => {
                                    if (count != 0) {
                                        setCount(count - 1)
                                    }
                                }}
                            >
                                <i class="fa-solid fa-square-caret-left"></i>
                            </span>
                            {selectedImage && selectedImage.length > 0 ? (
                                <>
                                    <img
                                        src={selectedImage[count]?.image}
                                        style={{
                                            width: 700,
                                            height: 700,
                                            objectFit: "cover",
                                        }}
                                        alt="Selected"
                                    />
                                </>
                            ) : (
                                <img
                                    src={IMAGE.NOIMAGE}
                                    style={{ width: 500, height: 500 }}
                                    alt="No image available"
                                />
                            )}
                            <span onClick={() => {
                                if (selectedImage?.length == count + 1) {
                                    setCount(0)
                                } else {
                                    setCount(count + 1)

                                }
                            }} className="assets-n" >

                                <i class="fa-solid fa-square-caret-right"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AssetsPreview
